import React from 'react'
import Button from './styled/Button'

const CTAButton = ({ children, onClick }) => {
    return (
        <Button
            onClick={onClick}
            type="button"
            style={{
                fontSize: '1.5rem',
                textTtransform: 'uppercase',
                borderRadius: '2rem',
                padding: '0.5rem 2rem',
            }}
        >
            {children}
        </Button>
    )
}

export default CTAButton
